import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthContext } from './hooks/useAuthContext';

// Pages and components
import Annotate from './pages/Annotate';
import MaskHistory from './pages/MaskHistory';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Reset_Password from './pages/Reset_Password';
import Reset_Password_Continued from './pages/Reset_Password_Continued';
import HistoryBot from './pages/HistoryBot';
import Instructions from './pages/Instructions';
import MyQueries from './pages/MyQueries'; // Import MyQueries page

import React from 'react';

function App() {
  const { user } = useAuthContext();

    return (
        <div className="App">
            <BrowserRouter>
                <div className="pages">
                    <Routes>
                        {/* Pass the view state to Home */}
                        <Route 
                            path="/" 
                            element={user ?
                                <Annotate /> :
                                <Navigate to="/login" />
                            }
                        />
                        <Route path="/mask-history" element={user ? <MaskHistory /> : <Navigate to="/login" />} />
                        <Route path="/historyBot" element={user ? <HistoryBot /> : <Navigate to="/login" />} />
                        
                        {/* Remove these routes as they're now handled within Home */}
                        {/* <Route path="/Instructions" element={user ? <Instructions /> : <Navigate to="/login" />} />
                        <Route path="/my-queries" element={user ? <MyQueries /> : <Navigate to="/login" />} /> */}
                        
                        {/* Public routes */}
                        <Route path="/login" element={!user ? <Login /> : <Navigate to="/" />} />
                        <Route path="/signup" element={!user ? <Signup /> : <Navigate to="/" />} />
                        <Route path="/reset_password" element={!user ? <Reset_Password /> : <Navigate to="/" />} />
                        <Route path="/reset_password_continued" element={!user ? <Reset_Password_Continued /> : <Navigate to="/" />} />
                    </Routes>
                </div>
            </BrowserRouter>
        </div>
    );
}

export default App;